import { useContext } from "react";
import { Box, Grid, Typography } from "@mui/material";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import { useTranslation } from "react-i18next";
import { RestaurantContext } from "src/Utils/Context/RestaurantContext";
import { CircularLoader } from "src/design/CircularLoader";
import {
  colorSurface,
  colorBorder,
  colorTextPrimary,
  colorTextMuted,
  radiusCard,
  shadowCard,
} from "src/design/tokens";
import { UnsubscribedRestaurantsCard } from "./components/UnsubscribedRestaurantsCard";

export const NoRestaurant = () => {
  const { t } = useTranslation();
  const { unsubscribedRestaurants, unsubscribedRestaurantsLoading } =
    useContext(RestaurantContext);

  // Nothing is said until the organization has answered: "contact your
  // administrator" is the wrong message for an owner who just unsubscribed.
  if (unsubscribedRestaurantsLoading) {
    return (
      <Grid container justifyContent="center" sx={{ width: "100%", py: 6 }}>
        <Grid item>
          <CircularLoader />
        </Grid>
      </Grid>
    );
  }

  // An owner who unsubscribed is not a user waiting for access: the organization
  // still holds the restaurant, so point them at what they can still do with it
  // rather than at their administrator.
  if (unsubscribedRestaurants.length > 0) {
    return (
      <Grid container justifyContent="center" sx={{ width: "100%", py: 6, px: 2 }}>
        <Grid item xs={12} sm={10} md={7}>
          <UnsubscribedRestaurantsCard restaurants={unsubscribedRestaurants} />
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container justifyContent="center" sx={{ width: "100%", py: 6, px: 2 }}>
      <Grid item xs={12} sm={8} md={5}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            gap: 1.5,
            backgroundColor: colorSurface,
            border: `1px solid ${colorBorder}`,
            borderRadius: radiusCard,
            boxShadow: shadowCard,
            px: { xs: 3, sm: 5 },
            py: { xs: 4, sm: 5 },
          }}
        >
          <StorefrontOutlinedIcon sx={{ fontSize: 40, color: colorTextMuted }} />
          <Typography
            sx={{ fontWeight: 700, fontSize: "18px", color: colorTextPrimary }}
          >
            {t("noRestaurant.title")}
          </Typography>
          <Typography sx={{ fontSize: "14px", color: colorTextMuted }}>
            {t("noRestaurant.message")}
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
};
